import { useEffect, useState } from 'react';

const stats = [
  { value: '+50mil', label: 'participantes' },
  { value: '100%', label: 'gratuito' },
  { value: '38+', label: 'anos de mercado' },
];

export default function HeroSection() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 80);
    return () => clearTimeout(t);
  }, []);

  return (
    <section className="relative flex items-center justify-center overflow-hidden" style={{ minHeight: '72vh' }}>
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/0de52ad5d056dfc5d9902b9e1495a971.jpg"
          alt="Fashion Background"
          className="w-full h-full object-cover object-top"
          loading="eager"
        />
        <div
          className="absolute inset-0"
          style={{ background: 'linear-gradient(180deg, rgba(0,0,0,0.82) 0%, rgba(0,0,0,0.72) 40%, rgba(0,0,0,0.96) 100%)' }}
        />
      </div>

      {/* Content */}
      <div
        className="relative z-10 w-full max-w-2xl mx-auto px-5 sm:px-8 pt-24 pb-8 text-center flex flex-col items-center"
        style={{
          opacity: visible ? 1 : 0,
          transform: visible ? 'translateY(0)' : 'translateY(20px)',
          transition: 'opacity 0.7s ease, transform 0.7s ease',
        }}
      >
        {/* Check icon */}
        <div
          className="w-16 h-16 flex items-center justify-center rounded-full mb-5"
          style={{
            background: 'linear-gradient(135deg, #EAB308, #CA8A04)',
            boxShadow: '0 0 28px rgba(234,179,8,0.45)',
          }}
        >
          <i className="ri-check-line text-3xl text-black" style={{ fontWeight: 900 }} />
        </div>

        {/* Title */}
        <h1
          className="text-3xl sm:text-5xl font-black text-white mb-3 leading-tight"
          style={{ fontFamily: 'Montserrat, sans-serif' }}
        >
          ✅ Sua inscrição foi{' '}
          <span
            className="text-transparent bg-clip-text"
            style={{ backgroundImage: 'linear-gradient(135deg, #EAB308, #FDE68A)' }}
          >
            confirmada
          </span>
        </h1>

        {/* Subtitle */}
        <p
          className="text-base sm:text-lg font-semibold text-white/90 mb-2"
          style={{ fontFamily: 'Montserrat, sans-serif' }}
        >
          Você garantiu sua vaga na seletiva presencial
        </p>

        {/* Description */}
        <p
          className="text-sm mb-8 leading-relaxed max-w-sm"
          style={{ color: '#9CA3AF', fontFamily: 'Montserrat, sans-serif', fontWeight: 300 }}
        >
          Leia com atenção as informações abaixo para chegar preparado(a) no dia da seleção.
        </p>

        {/* Trust line */}
        <div className="flex flex-wrap items-center justify-center gap-4 sm:gap-6 mb-8 text-xs">
          {[
            { icon: 'ri-check-fill', text: '100% gratuito' },
            { icon: 'ri-check-fill', text: 'Sem experiência necessária' },
            { icon: 'ri-shield-check-fill', text: 'Evento seguro' },
          ].map(t => (
            <span
              key={t.text}
              className="flex items-center gap-1.5"
              style={{ color: '#9CA3AF', fontFamily: 'Montserrat, sans-serif' }}
            >
              <i className={`${t.icon} text-yellow-500`} />
              {t.text}
            </span>
          ))}
        </div>

        {/* Stats bar */}
        <div
          className="w-full rounded-xl grid grid-cols-3 gap-0 overflow-hidden"
          style={{ background: 'linear-gradient(135deg, #EAB308, #CA8A04)' }}
        >
          {stats.map((s, i) => (
            <div
              key={s.label}
              className={`flex flex-col items-center py-3 ${i < stats.length - 1 ? 'border-r border-black/20' : ''}`}
            >
              <span
                className="text-base sm:text-xl font-black text-black leading-none"
                style={{ fontFamily: 'Montserrat, sans-serif' }}
              >
                {s.value}
              </span>
              <span
                className="text-[10px] sm:text-xs font-semibold text-black/70 mt-0.5"
                style={{ fontFamily: 'Montserrat, sans-serif' }}
              >
                {s.label}
              </span>
            </div>
          ))}
        </div>

        {/* Bounce arrow */}
        <div className="mt-6 animate-bounce">
          <i className="ri-arrow-down-line text-xl" style={{ color: '#EAB308' }} />
        </div>
      </div>
    </section>
  );
}
